import rounding from "./setting/rounding";
export default {
    namespaced: true,
    modules: {
        rounding: rounding   
    }
}
